import { ONBOARDING_DATA_TYPE_OPTIONS } from '@deepguide-ai/types'
import { MultiSelect } from '@deepguide-ai/ui/multi-select'

export function VendorCustomerDataSelect({ involved, dataTypes, onChange, disabled = false }: {
  involved?: boolean | null
  dataTypes?: string[] | null
  onChange: (involved: boolean, dataTypes: string[]) => void
  disabled?: boolean
}) {
  const options = ONBOARDING_DATA_TYPE_OPTIONS.filter(option => !['EMPLOYEE', 'IP'].includes(option.value))
  const types = dataTypes ?? []
  return <MultiSelect
    aria-label='Customer data'
    disabled={disabled}
    options={[
      { value: '_none', label: 'No customer data', excludeFromSelectAll: true },
      ...options,
      ...types.filter(type => !options.some(option => option.value === type)).map(type => ({ value: type, label: type })),
    ]}
    value={types.length ? types : involved === false ? ['_none'] : []}
    onValueChange={(values) => {
      const next = values.at(-1) === '_none' ? [] : values.filter(value => value !== '_none')
      onChange(next.length > 0, next)
    }}
    placeholder='Select customer data types'
  />
}
